export default __webpack_public_path__ + "static/barlow-v4-latin-regular-03b319cf330aed33fc00c1e10c91ebff.ttf";